import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FamilyMember } from 'core'

import { Button, DefaultSelectV2 } from 'common/components'

type Props = {
  name: string
  isForSelf: boolean
  familyMembers: FamilyMember[]
  onChange: (arg: any) => any
}

const SelectExpenseForDependent = ({ name, isForSelf, familyMembers, onChange }: Props) => {
  const { t: translate } = useTranslation(['ee-dashboard', 'translation'])
  const [open, setOpen] = useState(false)

  const handleDropdownVisibleChange = (open: boolean) => {
    setOpen(open)
  }

  const dependents = (() => {
    const defaults = isForSelf ? [] : [{ id: 'me', name: 'Me' }]
    return [
      ...defaults,
      ...familyMembers?.map(({ id, firstName, lastName }) => ({ id, name: `${firstName} ${lastName}` })),
    ]
  })()

  return (
    <DefaultSelectV2
      name={name}
      mode="multiple"
      label="Who else is covered by this policy?"
      placeholder="Select a dependent"
      items={dependents}
      onChange={(e) => {
        handleDropdownVisibleChange(false)
        onChange(e)
      }}
      onClick={() => {
        !open && handleDropdownVisibleChange(true)
      }}
      onDropdownVisibleChange={handleDropdownVisibleChange}
      open={open}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Button
            className="w-100 flex flex__align_center"
            type="text"
            icon="fa fa-plus"
            onClick={() => {
              onChange('add')
              handleDropdownVisibleChange(false)
            }}
          >
            {translate('get-reimburse.request.add-family-member-label')}
          </Button>
        </>
      )}
    />
  )
}

export default SelectExpenseForDependent
